/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function SocialBar(props) {
  return (
    <div
      css={css`
        ${globals.card}
        text-align: center;
        font-size: 14px;
        font-weight: bold;

        p {
          margin: 0;
          display: inline-block;
          vertical-align: middle;
        }
        span {
          display: inline-block;
        }
        span a img {
          height: 16px;
          margin: 2px 4px 0;
          display: inline-block;
          vertical-align: middle;
        }
      `}
    >
      <p>For all the latest updates, follow our social channels:</p>
      <span>
        <a href="https://www.facebook.com/dailybruin">
          <img src={require("./facebook.svg")} />
        </a>
        <a href="https://www.twitter.com/dailybruin">
          <img src={require("./twitter.svg")} />
        </a>
        <a href="https://www.instagram.com/dailybruin">
          <img src={require("./instagram.svg")} />
        </a>
        <a href="http://eepurl.com/cFEiZX">
          <img src={require("./mail.svg")} />
        </a>
      </span>
    </div>
  );
}
